// extracted by mini-css-extract-plugin
export default {"easy":"GameBoard_easy__a4PZs","normal":"GameBoard_normal__TGsft","hard":"GameBoard_hard__kPLp0"};